<template>
    <div>
        <section v-if="logOff">
            <h3>로그인</h3>
            <div class="mt-2">
                <v-text-field v-model="username" outlined hide-details type="text" label="아이디" class="d-inline-block"/>
            </div>
            <div class="mt-2">
                <v-text-field v-model="password" outlined hide-details type="password" label="비밀번호" class="d-inline-block" />
            </div>
            <div class="mt-2">
                <v-btn color="primary" @click="login()">로그인</v-btn>
            </div>
        </section>

        <section v-if="logOn">
            <h3>로그아웃</h3>
            <v-btn color="primary" @click="logout()">로그아웃</v-btn>
        </section>
    </div>
</template>

<script>
export default {
    data(){
        return {
            username: null,
            password: null
        }
    },
    methods: {
        async login(){
            await this.$store.dispatch("login", {
                username: this.username,
                password: this.password
            });
        },
        async logout(){
            await this.$store.dispatch("logout");
        }
    },
    computed: {
        logOn(){ return !!this.$store.state.accessToken; },
        logOff(){ return !this.$store.state.accessToken; }
    }
}
</script>